const ITEMS = [
  "Fire Safety Systems",
  "CCTV & Security",
  "Access Control & Entry",
  "Monitoring & Personal Protection",
  "Design · Install · Maintain",
  "Nationwide Coverage",
];

export default function Marquee() {
  return (
    <section
      aria-label="FSS service divisions"
      className="bg-slate-900 border-y border-slate-800 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="fss-marquee flex w-max whitespace-nowrap py-5">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {ITEMS.map((t, i) => (
              <span key={i} className="flex items-center">
                <span className="px-6 font-display text-lg md:text-2xl font-semibold uppercase tracking-[0.18em] text-slate-100">
                  {t}
                </span>
                <span className={`w-2.5 h-2.5 ${i % 2 ? "bg-green-600" : "bg-red-600"}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
